;(function($){

    function BiddingDocuments() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        if($("#modal-bidding-documents").length > 0) {

            $("#modal-bidding-documents").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getUsers();
                    _.geContracts();
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    _.html = '<form id="form-bidding-documents" enctype="multipart/form-data">'+
                   '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="title">Titulo</label>' +
                                '<input type="text" id="title" name="title">' +
                            '</div>'+
                        '</div>'+                          
                   '</div>'+                   
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="file">Anexo</label>' +
                                '<div class="info">'+
                                    '<p>Para anexar mais de um arquivo, recomendamos arquivos .zip ou .rar</p>'+
                                '</div>'+
                                '<input type="file" id="file" name="file" data="upload">' +
                            '</div>'+
                        '</div>'+                             
                   '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<input type="hidden" id="bidding_id" name="bidding_id" value="'+_.bidding_id+'">' +
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != ""){
                    $('#modal-bidding-documents').iziModal('setTitle', 'Adicionar Documento');
                    $("#modal-bidding-documents .content").html(_.html);

                    _.myForm = $("#form-bidding-documents").validate({
                        rules: {
                            title: { required: true },
                            file: { required: true}
                        },
                        messages: {
                            title: { required: "Campo Obrigatório" },
                            file: { required: "Campo Obrigatório"}
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Preencha todos os campos.",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                        
                            $("#form-bidding-documents .btn-send").html("Enviando...");
                            
                            $.ajax({
                                type: "POST",
                                url: _.API + "licitacoes/documento",
                                cache: false,
                                contentType: false,
                                processData: false,
                                data: new FormData(form),
                                success: function(result)
                                {
                                    $("#form-bidding-documents .btn-send").html("Enviar");

                                    form.reset();

                                    $('#modal-bidding-documents').iziModal('close'); 

                                    swal({
                                        title: result.message,
                                        text: "Click no botão para fechar!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: false
                                    }).then(function() {
                                      location = location+"#documentos";

                                      location.reload(true);
                                    });                                        
                                },
                                error: function(response) {
                                    var errors = $.parseJSON(response.responseText);
                                    
                                    swal({
                                        title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                        text: "Click no botão para fechar!",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: true
                                    });

                                   
                                    $myForm.showErrors(errors);
                                    
                                    $("#form-bidding-documents .btn-send").html("Enviar");
                                }
                            });
                        }
                    });
                }                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.bidding_id = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-bidding-documents .content").html("");
                    $('#modal-bidding-documents').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-create-bidding-documents ").on("click", function(e){
            e.preventDefault();
            _.bidding_id = $(this).data('bidding');
            $('#modal-bidding-documents').iziModal('open');           
        });
    }  

   	new BiddingDocuments();

}(jQuery));